(function () {
    'use strict';

    angular
        .module('aricControllers')
        .controller('AricController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'activeProcess']

    function Controller($scope, $state, topBarService, activeProcess) {
        topBarService.setTitleAndIcon('ARIC', 'fa fa-eye');

        if (!_.isObject(activeProcess) || _.isUndefined(activeProcess.GovernanceProcessID)) {
            $state.go('aricControlOwnerList.noActiveProcess', {}, { location: 'replace' });
        }
    }
})();